// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const profileRequestApi = baseApi.injectEndpoints({
  reducerPath: "profileRequestApi",
  endpoints: (builder) => ({
    updateRequest: builder.mutation({
      query: ({ data, id }) => {
        console.log(data);
        console.log(id);
        return {
          url: `admin/profile-update-request/status/${id}`,
          method: "PUT",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),

    getAllProfileRequest: builder.query({
      query: ({ limit, page }) => {
        // const queryParams = new URLSearchParams(params).toString();
        return {
          url: `admin/profile-update-request?page=${page}&limit=${limit}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),

    
    UploadImageS3: builder.mutation({
      query: ({ params }) => {
        const queryParams = new URLSearchParams(params).toString();
        return {
          url: `user/generate-presigned-url?${queryParams}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    
    UploadImage: builder.mutation({
      query: ({ params, body }) => {
        const queryParams = new URLSearchParams(params).toString();
        console.log(body);
        return {
          url: queryParams,
          method: "PUT",
          body: body,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    getAllNurseDocuments: builder.query({
      query: ({ limit, page }) => {
        // const queryParams = new URLSearchParams(params).toString();
        return {
          url: `admin/nurse-document?page=${page}&limit=${limit}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    updateDocuments: builder.mutation({
      query: ({ data, id }) => {
        console.log(data);
        console.log(id);
        return {
          url: `admin/nurse-document/${id}`,
          method: "PATCH",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useUpdateRequestMutation, useGetAllProfileRequestQuery, useUploadImageS3Mutation, useUploadImageMutation, useGetAllNurseDocumentsQuery, useUpdateDocumentsMutation } =
  profileRequestApi;
